import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// LOCAL FUNCTIONS
import { hasOptions } from '../functions';

// LOCAL COMPONENTS
import Control from './Control';
import DropdownIndicator from './DropdownIndicator';
import Input from './Input';
import Menu from './Menu';
import MenuList from './MenuList';
import MultiValueRemove from './MultiValueRemove';
import Option from './Option';
import ValueContainer from './ValueContainer';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT
export const COMPONENTS = {
  ClearIndicator: () => null,
  Control,
  DropdownIndicator,
  Group: props => <components.Group {...props} className={clsx('select-group', styles.group, props.className)} />,
  GroupHeading: props => <components.GroupHeading {...props} className={clsx('group-heading', styles.groupHeading, props.className)} />,
  IndicatorsContainer: props => props.isDisabled || !hasOptions(props.options) ? null : <components.IndicatorsContainer {...props} className={clsx('indicators-container', styles.indicatorsContainer, props.className)} />,
  IndicatorSeparator: () => null,
  Input,
  Menu: props => !hasOptions(props.options) ? null : <Menu {...props} />,
  MenuList,
  MultiValue: props => <components.MultiValue {...props} className={clsx('multi-value', styles.multiValue, props.className)} />,
  MultiValueRemove,
  Option,
  Placeholder: props => props.isDisabled ? null : <components.Placeholder {...props} className={clsx('select-placeholder', styles.placeholder, props.className)} />,
  SingleValue: props => props.data?.isCustom ? null : <components.SingleValue {...props} className={clsx('single-value', styles.singleValue, props.className)} />,
  ValueContainer
}
